import React, { useState, useEffect } from 'react'
import { DatePicker, Input, message, Modal, Select } from 'antd'
import moment from 'moment'

const { TextArea } = Input
const { Option } = Select

// Intermediate statuses (the 3 stages PLANNED/STARTED/COMPLETED are handled by create + Start/End).
const ADDABLE_STATUSES = ['ASSIGNED', 'PAUSED', 'CANCELLED']
const prettify = (v) => (v ? v.charAt(0) + v.slice(1).toLowerCase() : v)

function StatusUpdateModal ({ visible, trip, manpowerOptions = [], onSubmit, onCancel, loading }) {
  const [status, setStatus] = useState(undefined)
  const [dateTime, setDateTime] = useState(moment())
  const [remark, setRemark] = useState(undefined)
  const [manpower, setManpower] = useState(undefined)

  useEffect(() => {
    if (visible) {
      setStatus(undefined)
      setDateTime(moment())
      setRemark(undefined)
      setManpower(trip && trip.manpower ? ((trip.manpower._id) || trip.manpower) : undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, trip && trip._id])

  // Datetime of the last status entry - a new status cannot pre-date it.
  const lastEntry = trip && trip.statusHistory && trip.statusHistory.length
    ? trip.statusHistory[trip.statusHistory.length - 1]
    : null
  const lastTime = lastEntry && lastEntry.dateTime ? moment(lastEntry.dateTime) : null

  const handleOk = () => {
    if (!status) {
      message.error('Please select a status')
      return
    }
    if (lastTime && dateTime && dateTime.isBefore(lastTime)) {
      message.error(`Date/time cannot be before the previous status (${prettify(lastEntry.status)} at ${lastTime.format('DD/MM/YYYY HH:mm')})`)
      return
    }
    if (status === 'ASSIGNED' && !manpower) {
      message.error('Please select a driver to assign')
      return
    }
    onSubmit({
      status,
      dateTime: dateTime ? dateTime.toISOString() : undefined,
      remark: remark || undefined,
      manpower: status === 'ASSIGNED' ? manpower : undefined
    })
  }

  return (
    <Modal
      title={`Update Status${trip && trip.tripNo ? ` - ${trip.tripNo}` : ''}`}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText='Add Status'
      confirmLoading={loading}
      destroyOnClose
    >
      {lastTime && (
        <div style={{ marginBottom: 12, color: '#8c8c8c' }}>
          Current: <strong>{prettify(lastEntry.status)}</strong> at {lastTime.format('DD/MM/YYYY HH:mm')}
        </div>
      )}

      <div style={{ marginBottom: 4 }}>Status</div>
      <Select style={{ width: '100%' }} placeholder='Select status' value={status} onChange={setStatus}>
        {ADDABLE_STATUSES.map(s => <Option key={s} value={s}>{prettify(s)}</Option>)}
      </Select>

      {status === 'ASSIGNED' && (
        <div style={{ marginTop: 12 }}>
          <div style={{ marginBottom: 4 }}>Driver</div>
          <Select
            showSearch
            style={{ width: '100%' }}
            placeholder='Select driver'
            optionFilterProp='children'
            value={manpower}
            onChange={setManpower}
          >
            {manpowerOptions.map(m => <Option key={m._id} value={m._id}>{m.name}</Option>)}
          </Select>
        </div>
      )}

      <div style={{ marginTop: 12, marginBottom: 4 }}>Date &amp; Time</div>
      <DatePicker
        showTime
        format='DD/MM/YYYY HH:mm'
        style={{ width: '100%' }}
        value={dateTime}
        disabledDate={(current) => current && current > moment().endOf('day')}
        onChange={setDateTime}
      />

      <div style={{ marginTop: 12, marginBottom: 4 }}>Remark{(status === 'PAUSED' || status === 'CANCELLED') ? '' : ' (optional)'}</div>
      <TextArea rows={2} value={remark} onChange={(e) => setRemark(e.target.value)} />
    </Modal>
  )
}

export default StatusUpdateModal
